export default __webpack_public_path__ + "static/media/menora.8e6ed8ff.png";